module.exports = __webpack_public_path__ + "static/media/landing.8344835b.svg";